// product-compare-panel

if (!customElements.get("product-compare-panel")) {
  customElements.define(
    "product-compare-panel",
    class ProductComparePanel extends HTMLElement {
      /**
       * 代理源
       * @type {Ref}
       * */
      _refOrigin = {
        /** 当前选择的产品 */
        selectedProducts: [],
      };
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
        this.renderCompareInfo();
      }

      init() {
        const cards = document.querySelectorAll("product-card-v2");
        this.countEl = document.querySelector("[data-count]");
        this.maxSize = this.isMobile() ? 2 : 3;
        // 代理
        const proxyHandler = {
          get(target, key) {
            return target[key];
          },
          set: (target, property, value) => {
            // target[property] = value;
            if (property === "selectedProducts") {
              if (value.length > this.maxSize) {
                // alert("最多只能选择" + this.maxSize + "个产品");
                target.selectedProducts = value.slice(0, this.maxSize);
                // target[property] = target[property];
                return false;
              } else {
                document.querySelectorAll("product-card-v2").forEach((card) => {
                  const isInList = value.some((v) => {
                    return v.handle == card.getAttribute("data-product-handle");
                  });
                  if (isInList) {
                    if (!card.classList.contains("checked")) {
                      card.classList.add("checked");
                    }
                  } else {
                    if (card.classList.contains("checked")) {
                      card.classList.remove("checked");
                    }
                  }
                });
              }
            }
            // target[property] = value;
            Reflect.set(target, property, value);
            this.render(target, property, value);
            return true;
          },
        };

        const ref = new Proxy(this._refOrigin, proxyHandler);
        this.ref = ref;

        this.productsEl = this.querySelector("[data-selected-products]");
        const modalId = this.getAttribute("data-modal");
        this.modalEl = document.querySelector(modalId);
        this.modalInfoInner = document.querySelector(".modal-info-inner");
        this.resultEl = this.modalEl?.querySelector("[data-result]");
        this.compareButton = this.querySelector("compare-button");
        this.listenEvents();
      }
      isMobile() {
        return window.matchMedia("(max-width: 820px)").matches;
      }
      listenEvents() {
        let resizeTimeout;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => {
            this.maxSize = this.isMobile() ? 2 : 3;
            const count = this.ref.selectedProducts.length;
            this.countEl.innerHTML = ` (${count}/${this.maxSize})`;
            if (this.ref.selectedProducts.length > this.maxSize) {
              this.ref.selectedProducts = this.ref.selectedProducts.slice(
                0,
                this.maxSize
              );
            }
          }, 500);
        });
        this.querySelector(
          ".product-compare-panel-button-cancel"
        ).addEventListener("click", this.clearProducts.bind(this));
        this.compareButton.addEventListener("click", () => {
          this.filterCompareInfo();
        });
        this.addEventListener("facet:update", this.clearProducts.bind(this));
        this.addEventListener("compare:add", this.addProduct.bind(this));
        this.addEventListener("compare:remove", this.removeProduct.bind(this));
      }
      clearProducts() {
        this.ref.selectedProducts = this.ref.selectedProducts.slice(0, 0);
      }
      throttle(func, limit = 100) {
        let lastFunc;
        let lastRan;
        return function () {
          const context = this;
          const args = arguments;
          if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
          } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function () {
              if (Date.now() - lastRan >= limit) {
                func.apply(context, args);
                lastRan = Date.now();
              }
            }, limit - (Date.now() - lastRan));
          }
        };
      }
      addProduct(e) {
        if (this.ref.selectedProducts.length <= this.maxSize) {
          this.ref.selectedProducts.push({ ...e.detail.productJson });
          this.ref.selectedProducts = this.ref.selectedProducts;
          this.comparable()
          console.log("addProduct", this.ref.selectedProducts);
        }
      }
      removeProduct(e) {
        const index = this.ref.selectedProducts.findIndex((product) => {
          return product.handle == e.detail.productHandle;
        });
        if (index != -1) {
          this.ref.selectedProducts.splice(index, 1);
          this.ref.selectedProducts = this.ref.selectedProducts;
        }
        this.comparable()
        console.log("removeProduct", this.ref.selectedProducts);
      }
      comparable(){
        // 两个及以上才允许对比
        const compareBtn = document.querySelector(".product-compare-panel-button-compare");
        const count = this.ref.selectedProducts.length;
        if (compareBtn) {
          if (count < 2) {
            compareBtn.classList.add("disable");   // 给按钮加样式
            compareBtn.disabled = true;            // 禁用点击
          } else {
            compareBtn.classList.remove("disable");
            compareBtn.disabled = false;
          }
        }
      }
      render(target, property, value) {
        if (target.selectedProducts.length > 0) {
          // 渲染已选产品 Set
          if (this.classList.contains("panel-hidden")) {
            this.classList.remove("panel-hidden");
          }
          this.countEl.innerHTML = ` (${target.selectedProducts.length}/${this.maxSize})`;
          this.renderSelectedProducts(target.selectedProducts);
          this.renderResult(target.selectedProducts);
        } else {
          this.classList.add("panel-hidden");
        }
      }
      renderSelectedProducts(selectedProducts) {
        // 更多 (+号) 标识符
        const addSetItemHTML = `
        <div class="compare-item compare-item-add">
        +
        </div>
        `;
        // console.log("selectedProducts", selectedProducts);
        const setProductsData = { innerHTML: "" };
        const _products = [];
        // console.log("setProductsData", setProductsData);
        for (let i = 0; i < selectedProducts.length; i++) {
          const product = selectedProducts[i];
          _products.push(product);

          const productCardEl = document.querySelector(
            `[data-product-handle="${product.handle}"]`
          );
          const compareItem = productCardEl.querySelector(
            "[data-compare-selected-data]"
          );
          setProductsData.innerHTML += compareItem.innerHTML;
        }
        // 已选产品Set的更多 (+号) 标识符
        const minSetItemSize = 3;
        if (selectedProducts.length < minSetItemSize) {
          const offset = minSetItemSize - selectedProducts.length;
          for (let i = 0; i < offset; i++) {
            setProductsData.innerHTML += addSetItemHTML;
          }
        }
        // console.log("setProductsData", setProductsData);
        this.productsEl.innerHTML = setProductsData.innerHTML;
      }

      renderResult(selectedProducts) {
        const mediaQuery = window.matchMedia("(min-width: 550px)");
        const count = mediaQuery.matches ? 3 : 2;
        const result = { innerHTML: "" };

        for (let i = 0; i < count; i++) {
          const product = selectedProducts[i];
          if (product) {
            const productCardEl = document.querySelector(
              `[data-product-handle="${product.handle}"]`
            );
            const compareData = productCardEl.querySelector(
              "[data-compare-data]"
            );
            result.innerHTML += compareData.innerHTML;
          }
        }
        this.resultEl.innerHTML = result.innerHTML;
        console.log("result el", this.resultEl);
        let mhEl;
        this.resultEl
          .querySelectorAll(".product-compare-result-item-title")
          .forEach((titleEl) => {
            titleEl.classList.remove("highest");
            if (
              !mhEl ||
              titleEl.querySelector("span").getBoundingClientRect().height >
                mhEl.querySelector("span").getBoundingClientRect().height
            ) {
              mhEl = titleEl;
            }
          });
        mhEl.classList.add("highest");
        // console.log("el with max height", mhEl);
      }

      renderCompareInfo() {
        fetch("/pages/product-comparison")
          .then((response) => response.text())
          .then((htmlText) => {
            const html = new DOMParser().parseFromString(htmlText, "text/html");
            const quickLookEl = html.querySelector(".less-wrapper-sec");
            const contentWrapper = quickLookEl.closest(".content-wrapper");
            const section = quickLookEl.closest('[id^="shopify-section-"]');
            const sectionPageCompare = section.querySelector(
              ".section-page-compare"
            );
            // console.log("quickLookEl", quickLookEl);
            quickLookEl.querySelectorAll(".page-width").forEach((el) => {
              el.classList.remove("page-width");
            });
            const compareInfoWrapper = document.createElement("div");
            compareInfoWrapper.classList.add("compare-info");
            const innerSection = document.createElement("div");
            const innerContentWrapper = document.createElement("div");
            const innerStyle = section.querySelector("style");
            innerContentWrapper.classList.add("content-wrapper");
            innerSection.setAttribute(
              "class",
              sectionPageCompare.getAttribute("class")
            );
            innerContentWrapper.innerHTML = contentWrapper.innerHTML;
            innerSection.append(innerContentWrapper);
            compareInfoWrapper.append(innerSection);
            compareInfoWrapper.append(innerStyle);
            console.log("quickLookWrapper", compareInfoWrapper);
            this.modalInfoInner.append(compareInfoWrapper);

            this.modalInfoInner
              .querySelectorAll(".swiper-comparepro")
              .forEach((swiperEl) => {
                new Swiper(swiperEl, {
                  slidesPerView: 1,
                  pagination: {
                    el: swiperEl.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
                  navigation: {
                    nextEl: swiperEl.querySelector(".swiper-btn-next"),
                    prevEl: swiperEl.querySelector(".swiper-btn-prev"),
                  },
                  spaceBetween: 10,
                  observer: true,
                  observeParents: true,
                });
              });
            this.compareInfo = this.modalEl.querySelector(".compare-info");
            this.querySelector("compare-button").classList.remove("loading");
            // 请求结果回来后，需要根据已选产品进行筛选
            this.filterCompareInfo();
            document
              .querySelectorAll(".compare-select-button")
              .forEach((el) => {
                el.classList.remove("loading");
              });
            console.log(
              "this.modalEl",
              this.modalEl,
              this.modalEl.querySelector(".compare-info")
            );
            this.modalEl
              .querySelector(".more-wrapper .title")
              .addEventListener("click", () => {
                this.modalEl
                  .querySelector(".more-wrapper .title")
                  .classList.toggle("active");
                this.modalEl
                  .querySelectorAll(".more-wrapper .item:nth-of-type(n+3)")
                  .forEach((el) => {
                    // console.log("expand el 1", el);
                    this.toggleMoreInfo(el);
                  });

                const viewMoreBox = this.modalEl.querySelector(".viewmore-gdbox");
                // 切换 active
                viewMoreBox.classList.toggle("active");
                // 更新文字
                const textEl = viewMoreBox.querySelector(".viewmore-gdboxtext");
                if (viewMoreBox.classList.contains("active")) {
                  textEl.textContent = "Close";
                } else {
                  textEl.textContent = "View More";
                }
              });
            this.modalEl
              .querySelector(".viewmore-gdbox")
              .addEventListener("click", () => {
                const viewMoreBox =
                  this.modalEl.querySelector(".viewmore-gdbox");

                // 切换 active
                viewMoreBox.classList.toggle("active");

                // 更新文字
                const textEl = viewMoreBox.querySelector(".viewmore-gdboxtext");
                if (viewMoreBox.classList.contains("active")) {
                  textEl.textContent = "Close";
                } else {
                  textEl.textContent = "View More";
                }

                // 切换 more-wrapper 标题
                const titleEl = this.modalEl.querySelector(
                  ".more-wrapper .title"
                );
                titleEl.classList.toggle("active");

                // 展开或收起更多信息
                this.modalEl
                  .querySelectorAll(".more-wrapper .item:nth-of-type(n+3)")
                  .forEach((el) => {
                    this.toggleMoreInfo(el);
                  });
              });
          });
      }
      toggleMoreInfo(el) {
        // console.log("expand el 2", el);
        if (!this.moreInfoMoving) {
        }
        if (!el.classList.contains("expanded")) {
          // this.moreInfoMoving = true;
          let start;
          let duration = 500;
          let calcHeight = 0;
          el.style.height = `${calcHeight}px`;
          el.style.display = "flex";
          el.style.overflow = "hidden";
          let elementHeight = Math.floor(parseFloat(el.scrollHeight));
          let speed = elementHeight / duration;
          // console.log("elementHeight", elementHeight);
          const handleExpandAnimation = (timestamp) => {
            if (!start) {
              start = timestamp;
            }
            const elapsed = timestamp - start;
            el.style.height = `${Math.min(elapsed * speed, elementHeight)}px`;
            const shift = Math.min(elapsed * speed, elementHeight);
            // console.log("elapsed", elapsed, "speed", speed);
            if (shift < elementHeight) {
              window.requestAnimationFrame(handleExpandAnimation);
            } else {
              el.classList.add("expanded");
              el.style.overflow = "";
              // this.moreInfoMoving = false;
            }
          };
          window.requestAnimationFrame(handleExpandAnimation);
        } else {
          // this.moreInfoMoving = true;
          let start;
          let duration = 500;
          el.style.overflow = "hidden";
          let elementHeight = Math.floor(parseFloat(el.scrollHeight));
          let speed = elementHeight / duration;
          // console.log("elementHeight", elementHeight);
          const handleCollapseAnimation = (timestamp) => {
            if (!start) {
              start = timestamp;
            }
            const elapsed = timestamp - start;
            el.style.height = `${Math.max(
              elementHeight - elapsed * speed,
              0
            )}px`;
            const shift = Math.max(elementHeight - elapsed * speed, 0);
            // console.log("elapsed", elapsed, "speed", speed);
            if (shift > 0) {
              window.requestAnimationFrame(handleCollapseAnimation);
            } else {
              el.style.height = `${elementHeight}px`;
              el.style.display = "none";
              el.classList.remove("expanded");
              el.style.overflow = "";
              // this.moreInfoMoving = false;
            }
          };
          window.requestAnimationFrame(handleCollapseAnimation);
        }
      }
      expandMoreInfoAnimation(timestamp, start) {}

      filterCompareInfo(selectedProducts) {
        const selected = this.ref.selectedProducts;
        const selectedCount = selected.length;

        if (!this.compareInfo) return;

        // 遍历每个 item（行）
        const items = this.compareInfo.querySelectorAll(".item");

        items.forEach((item) => {
          const columns = item.querySelectorAll(".col-content-item");

          columns.forEach((col, index) => {
            const contentEls = col.querySelectorAll(".content.data");
            if (!contentEls.length) return;

            // 默认隐藏多余列
            if (index >= selectedCount) {
              col.style.display = "none";
              contentEls.forEach((content) => content.classList.remove("active"));
              return;
            }

            // 当前列显示并对应一个选中的产品
            const product = selected[index];
            col.style.display = "";

            // 遍历列内的所有 .content.data，匹配 handle 决定 active
            contentEls.forEach((content) => {
              if (content.dataset.handle === product.handle) {
                content.classList.add("active");
              } else {
                content.classList.remove("active");
              }
            });
          });
        });

        // 整体隐藏或显示 compareInfo
        this.compareInfo.style.display = selectedCount > 0 ? "" : "none";
      }

    }
  );
}

if (!customElements.get("compare-result")) {
  customElements.define(
    "compare-result",
    class CompareResult extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {}
    }
  );
}

if (!customElements.get("compare-button")) {
  customElements.define(
    "compare-button",
    class CompareButton extends ModalOpener {
      constructor() {
        super();
      }
    }
  );
}

if (!customElements.get("compare-item-remove")) {
  customElements.define(
    "compare-item-remove",
    class CompareItemRemove extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.panel = this.closest("product-compare-panel");
        this.handle = this.getAttribute("data-handle");
        this.addEventListener("click", (e) => {
          this.panel.dispatchEvent(
            new CustomEvent("compare:remove", {
              detail: {
                productHandle: this.handle,
              },
            })
          );
        });
      }
    }
  );
}
